var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms-tracking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 17.7083H5.83333C5.49167 17.7083 5.20833 17.425 5.20833 17.0833C5.20833 16.7417 5.49167 16.4583 5.83333 16.4583H14.1667C16.55 16.4583 17.7083 15.3 17.7083 12.9167V7.08333C17.7083 4.7 16.55 3.54167 14.1667 3.54167H5.83333C3.45 3.54167 2.29167 4.7 2.29167 7.08333C2.29167 7.425 2.00833 7.70833 1.66667 7.70833C1.325 7.70833 1.04167 7.425 1.04167 7.08333C1.04167 4.04167 2.79167 2.29167 5.83333 2.29167H14.1667C17.2083 2.29167 18.9583 4.04167 18.9583 7.08333V12.9167C18.9583 15.9583 17.2083 17.7083 14.1667 17.7083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99982 10.725C9.29982 10.725 8.59149 10.5083 8.04982 10.0666L5.44148 7.98331C5.17481 7.76664 5.12482 7.37497 5.34149 7.10831C5.55815 6.84164 5.94981 6.79164 6.21648 7.00831L8.82481 9.09164C9.45815 9.59998 10.5331 9.59998 11.1665 9.09164L13.7748 7.00831C14.0415 6.79164 14.4415 6.83331 14.6498 7.10831C14.8665 7.37497 14.8248 7.77498 14.5498 7.98331L11.9415 10.0666C11.4081 10.5083 10.6998 10.725 9.99982 10.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66667 14.375H1.66667C1.325 14.375 1.04167 14.0917 1.04167 13.75C1.04167 13.4083 1.325 13.125 1.66667 13.125H6.66667C7.00833 13.125 7.29167 13.4083 7.29167 13.75C7.29167 14.0917 7.00833 14.375 6.66667 14.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.16667 11.0417H1.66667C1.325 11.0417 1.04167 10.7583 1.04167 10.4167C1.04167 10.075 1.325 9.79167 1.66667 9.79167H4.16667C4.50833 9.79167 4.79167 10.075 4.79167 10.4167C4.79167 10.7583 4.50833 11.0417 4.16667 11.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.a0e0bbb538d9d45d433b24b4bd40216a.svg";